import { render, staticRenderFns } from "./GraphDetail84.vue?vue&type=template&id=06b6588b&scoped=true"
import script from "./GraphDetail84.vue?vue&type=script&lang=js"
export * from "./GraphDetail84.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b6588b",
  null
  
)

export default component.exports